export function populatePopup(property) {
  const template = document.querySelector(".map-popup__template");

  const HTMLLabel = getlabel(property.property_id);

  const object = {
    property_name: property.property_name,
    area_name: property.area_name,
    description: property.property_description,
    image_src: property.property_image_path,
    image_alt: Drupal.t("Image of the property") + " " + property.property_name,
    link_property: property.property_page_url,
    total_amount_of_residences: property.property_total_amount_of_residences,
    amount_of_square_feet: property.property_amount_of_square_feet,
    amount_of_rooms: property.property_amount_of_rooms,
  };

  const clonenode = template.content.cloneNode(true);
  const clone = clonenode.querySelector.bind(clonenode);

  clone(".js-map-popup__image").src = object.image_src;
  clone(".js-map-popup__image").alt = object.image_alt;
  clone(".js-map-popup__title").textContent = object.property_name;
  clone(".js-map-popup__area-title").textContent = object.area_name;
  clone(".js-map-popup__redirect").href = object.link_property;
  clone(".js-map-popup__total_amount-of-residences span").textContent =
    object.total_amount_of_residences;
  clone(".js-map-popup__amount-of-rooms").textContent = object.amount_of_rooms;
  clone(".js-map-popup__amount-of-square-feet").textContent =
    object.amount_of_square_feet;

  if (HTMLLabel) {
    clone(".js-map-popup__image-container").insertAdjacentHTML(
      "beforeend",
      HTMLLabel
    );
  }

  const wrapper = document.createElement("div");
  wrapper.appendChild(clonenode);

  return wrapper.innerHTML;
}

function getlabel(id) {
  const element = document.querySelector(`#map-property_id_${id}`);

  if (element) {
    return element.querySelector(".residence-label").outerHTML;
  }
}
